<template>
  <v-dialog
    v-model="showDetailDialog"
    max-width="60%"
    persistent
    scrollable
    :width="isMobile.isMobile ? '340px !important' : ''"
  >
    <v-card
      class="window-card px-4 py-5"
      :style="{ padding: isMobile.isMobile ? '0px !important' : '' }"
    >
      <v-card-title>
        <span class="md-title" style="color: #67ad5b">设备模型信息</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text :style="{ padding: isMobile.isMobile ? '0px 5px !important' : '' }">
        <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
          <v-tabs-slider color="green"></v-tabs-slider>
          <v-tab
            v-for="(item, index) in items"
            :key="item"
            :class="index == 0 ? 'viewModelTab' : 'viewModePreview'"
          >
            {{ item }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-form class="pa-10">
              <v-text-field
                v-model="currentResource.model_name"
                label="名称 *"
                color="#4caf50"
                :rules="[v => !!v || '名称不能为空']"
                class="model_name"
              ></v-text-field>
              <v-select
                v-model="currentResource.model_category"
                :items="categoryList"
                item-text="name"
                color="#4caf50"
                item-value="type"
                label="类型 *"
                no-data-text="暂无数据"
                :rules="[v => !!v || '类型不能为空']"
                class="model_category"
              ></v-select>
              <v-select
                v-model="currentResource.one_level_classify"
                :items="majorListData"
                item-text="name"
                item-value="code"
                label="分类 *"
                color="#4caf50"
                no-data-text="暂无数据"
                :rules="[v => !!v || '专业分类不能为空']"
                class="one_level_classify"
              ></v-select>
              <!-- <v-select
              :items="level2"
              item-text="name"
              color="#4caf50"
              item-value="index"
              no-data-text="暂无数据"
              label="二级分类"
            ></v-select>
            <v-select
              :items="level3"
              item-text="name"
              color="#4caf50"
              item-value="index"
              no-data-text="暂无数据"
              label="三级分类"
            ></v-select> -->
              <v-textarea
                v-model="currentResource.description"
                label="描述"
                color="#4caf50"
                dense
                auto-grow
              ></v-textarea>
              <v-textarea
                v-model="currentResource.model_remark"
                label="备注"
                color="#4caf50"
                dense
                auto-grow
              ></v-textarea>
              <!-- <v-select
              class="tags"
              :items="tagList"
              v-model="currentResource.tags"
              item-value="_id"
              item-text="name"
              label="标签"
              multiple
            ></v-select> -->
            </v-form>
          </v-tab-item>
          <v-tab-item>
            <iframe
              :src="editorUrl"
              ref="iframe"
              width="100%"
              scrolling="no"
              style="min-height: calc(65vh)"
              id="myIframe"
              @load="onIframeLoad"
            ></iframe>
            <!-- <iframe :src="" ref="iframe" width="100%"
            scrolling="no" style="min-height: calc(65vh)"></iframe> -->
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions
        class="md-layout md-gutter md-alignment-center-center BtnsWrap"
        v-if="isMobile.isMobile"
      >
        <v-spacer></v-spacer>
        <span
          style="position: absolute; left: 55px"
          class="neiZhiYuanJianPc"
          v-hasPermi="['dev::model:isInternalModel']"
          >内置元件：<v-switch
            v-model="currentResource.isInternalModel"
            flat
            color="success"
            style="display: inline-block"
          ></v-switch
        ></span>
        <span class="neiZhiYuanJian" v-hasPermi="['dev::model:isInternalModel']"
          >内置元件：<v-switch
            v-model="currentResource.isInternalModel"
            flat
            color="success"
            style="display: inline-block"
          ></v-switch
        ></span>

        <v-menu top :close-on-content-click="closeOnContentClick">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="success" dark v-bind="attrs" v-on="on"> 操作 </v-btn>
          </template>

          <v-list>
            <v-list-item link v-hasPermi="['dev::model::updateModel']">
              <v-list-item-title @click="BtnupdateModel">更新模型</v-list-item-title>
            </v-list-item>

            <v-list-item link v-hasPermi="['dev::model::download']">
              <v-list-item-title @click="download"> 下载模型原件 </v-list-item-title>
            </v-list-item>

            <v-list-item link v-hasPermi="['dev::model::edit']">
              <v-list-item-title @click="submit">确定</v-list-item-title>
            </v-list-item>

            <v-list-item link v-hasPermi="['dev::model::remove']">
              <v-list-item-title @click="delete_"> 删除</v-list-item-title>
            </v-list-item>

            <v-list-item link @click="cancel">
              <v-list-item-title> 关闭 </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-card-actions>
      <v-card-actions v-else class="md-layout md-gutter md-alignment-center-center BtnsWrap">
        <v-spacer></v-spacer>

        <span
          style="position: absolute; left: 55px"
          class="neiZhiYuanJianPc"
          v-hasPermi="['dev::model:isInternalModel']"
          >内置元件：<v-switch
            v-model="currentResource.isInternalModel"
            flat
            color="success"
            style="display: inline-block"
          ></v-switch
        ></span>

        <span class="neiZhiYuanJian" v-hasPermi="['dev::model:isInternalModel']"
          >内置元件：<v-switch
            v-model="currentResource.isInternalModel"
            flat
            color="success"
            style="display: inline-block"
          ></v-switch
        ></span>
        <v-btn
          v-hasPermi="['dev::model::updateModel']"
          color="success"
          class="updateModel md-layout-item md-xlarge-size-10 md-large-size-10 md-medium-size-15 md-small-size-20 md-xsmall-size-45"
          small
          @click="BtnupdateModel"
          >更新模型</v-btn
        >
        <v-btn
          v-hasPermi="['dev::model::download']"
          color="success"
          class="downModel md-layout-item md-xlarge-size-10 md-large-size-10 md-medium-size-15 md-small-size-20 md-xsmall-size-45"
          small
          @click="download"
          >下载模型原件</v-btn
        >
        <v-btn
          v-hasPermi="['dev::model::edit']"
          color="success"
          class="md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-5 md-small-size-15 md-xsmall-size-25"
          @click="submit"
          small
          >确定</v-btn
        >
        <v-btn
          v-hasPermi="['dev::model::remove']"
          color="error"
          class="delModel md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-5 md-small-size-15 md-xsmall-size-25"
          @click="delete_"
          small
          >删除</v-btn
        >
        <v-btn
          color="success"
          class="md-layout-item md-xlarge-size-5 md-large-size-5 md-medium-size-5 md-small-size-15 md-xsmall-size-25"
          @click="cancel"
          small
          >关闭</v-btn
        >
      </v-card-actions>
    </v-card>
    <!-- 算是标准的表单模板，后续需要封装一个 -->
    <v-dialog v-model="showUploadUpdateModel" max-width="500px" transition="dialog-transition">
      <v-card class="d-flex flex-column justify-center white pa-10">
        <v-file-input
          truncate-length="15"
          color="#4caf50"
          label="模型预览图片上传"
          @change="f => (form.model_image = fileChange(f))"
          :value="form.model_image"
          accept="image/*"
          show-size
        ></v-file-input>
        <v-file-input
          truncate-length="15"
          color="#4caf50"
          label="修改模型上传"
          @change="f => (form.modelFile = f)"
          accept=".fbx,.FBX"
          show-size
        ></v-file-input>

        <v-overlay :value="overlay">
          <v-card class="d-flex flex-column justify-center white px-10">
            <div class="d-flex justify-center py-5">
              <v-progress-circular indeterminate color="success"></v-progress-circular>
            </div>
            <div class="d-flex justify-center pb-5 green--text text-bold">模型资源上传中...</div>
          </v-card>
        </v-overlay>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" v-hasPermi="['dev::model::updateModel']" @click="updateModel" small
            >更新</v-btn
          >
          <v-btn color="success" @click="showUploadUpdateModel = false" small>取消</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
import { ImageCard, Pagination } from '@/components';
import { ModelFbx } from 'vue-3d-model';
import Swal from 'sweetalert2';
import model_resource_name_map from '../../../../../common/config/model_resource_name_map';
import { updateModelResource, deleteResource } from '@/api/model_resource';
import { ossUpload } from '@/api/user';
import { saveAs } from 'file-saver';
import { listTag } from '@/api/tag';
import { mapGetters } from 'vuex';
export default {
  components: {
    ImageCard,
    Pagination,
    ModelFbx,
  },
  props: {
    showDetailDialog: {
      type: Boolean,
      default: false,
    },
    selectedResource: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['isMobile','permissions']),
    editorUrl() {
      return `${process.env.VUE_APP_PREVIEW_URL}#/preview?id=${this.currentResource._id}`;
    },
    model_resource_category() {
      return model_resource_name_map(this.$route.path);
    },
    // allSelected() {
    //   return this.selected.length === this.items.length;
    // },
    categories() {
      const search = this.search.toLowerCase();

      if (!search) return this.items;

      return this.items.filter(item => {
        const text = item.text.toLowerCase();

        return text.indexOf(search) > -1;
      });
    },
    selections() {
      const selections = [];

      for (const selection of this.selected) {
        selections.push(selection);
      }

      return selections;
    },
  },
  data() {
    return {
      closeOnContentClick: true,
      overlay: false,
      modelFile: null,
      form: {
        model_image: null,
        modelFile: null,
      },
      model_image: null,
      showUploadUpdateModel: false,
      tab: 0,
      items: ['基本信息', '模型预览'],
      // 专业分类
      majorListData: [],
      // 二级分类
      level2: [],
      // 三级分类
      level3: [],
      currentResource: this.selectedResource,
      message: '',
      categoryList: [
        { name: '设备', type: 'device' },
        { name: '角色', type: 'role' },
        { name: '工具', type: 'tool' },
        { name: '场景', type: 'scene' },
      ],
      // allSelected: false,
      loading: false,
      search: '',
      selected: [],
      tagList: [],
    };
  },
  watch: {
    selected() {
      this.search = '';
    },
    tab(val) {
      if (val == 1 && !this.currentResource.model_amrt_file_list_json) {
        this.$store.dispatch('global/showWarningMsg', '模型尚未转换无法预览');
        this.tab = 0;
      }
    },
  },
  mounted() {
    this.initDict('device');
    this.getTagList();
    let that = this;
    this.$EventBus.$on('setTabChange', function (data) {
      if (data == 0) {
        that.tab = 0;
      } else {
        that.tab = 1;
      }
    });
    if (this.currentResource) {
      this.model_image = this.currentResource.model_image;
      this.modelFile = this.currentResource.model_file;
    }
    // myIframe
    // console.log(`${process.env.VUE_APP_PREVIEW_URL}#/preview?id=${this.currentResource._id}`)
  },
  destroyed() {
    this.$EventBus.$off('setTabChange');
  },
  methods: {
    onIframeLoad() {
      if (this.tab == 1 && this.currentResource.model_amrt_file_list_json) {
        const iframe = this.$refs.iframe;
      // 确保iframe已加载完成
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage({permissions:this.permissions}, '*'); // 可以指定接收消息的源，'*' 表示任何源，出于安全考虑，建议指定具体源
      }
      }
    },

    BtnupdateModel() {
      this.model_image = this.currentResource.model_image;
      this.modelFile = this.currentResource.model_file;
      // this.form
      this.showUploadUpdateModel = true;
    },
    fileChange(e) {
      console.log({
        e,
        f: this.form.model_image,
      });
      return e;
    },
    async getTagList() {
      const res = await listTag({ perPage: 1000, currentPage: 1 });
      this.tagList = res.data.rows;
    },
    async uploadFile(fieldName, file) {
      const res = await ossUpload({ path: fieldName, file });
      return res.url;
    },
    async updateModel() {
      if (!this.form.modelFile && !this.form.model_image) {
        this.$notify({
          timeout: 1500,
          message: '请选择要更新的资源',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'warning',
        });
      }

      if (!this.form.modelFile && this.form.model_image) {
        let result = await Swal.fire({
          title: '更新信息',
          text: `确定只更新模型预览图片?`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'md-button md-success btn-fill',
          cancelButtonClass: 'md-button md-danger btn-fill',
          confirmButtonText: '确 定',
          cancelButtonText: '取 消',
          buttonsStyling: false,
        });
        if (result.value) {
          this.overlay = true;
          this.model_image = await this.uploadFile('modelImage', this.form.model_image);
          this.submit();
          return false;
        }
        this.overlay = false;
        return false;
      }

      if (!this.form.model_image && this.form.modelFile) {
        let result = await Swal.fire({
          title: '更新信息',
          text: `确定只更新模型?`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'md-button md-success btn-fill',
          cancelButtonClass: 'md-button md-danger btn-fill',
          confirmButtonText: '确 定',
          cancelButtonText: '取 消',
          buttonsStyling: false,
        });
        if (result.value) {
          this.overlay = true;
          this.modelFile = await this.uploadFile('modelFile', this.form.modelFile);
          this.submit();
        }
        this.overlay = false;
        return false;
      }

      if (this.form.modelFile && this.form.model_image) {
        this.overlay = true;
        this.model_image = await this.uploadFile('modelImage', this.form.model_image);
        this.modelFile = await this.uploadFile('modelFile', this.form.modelFile);
        this.overlay = false;
        this.submit();
        return false;
      }
    },
    download() {
      let url = /https.*/.test(this.currentResource.model_file)
        ? this.currentResource.model_file
        : this.currentResource.model_file.replace(`http`, 'https');
      console.log('url :>> ', url);
      saveAs(url, `${this.currentResource.model_name}.fbx`);
      // window.open(this.currentResource.model_file)
    },
    /**
     * 初始化字典
     */
    initDict(cate_type) {
      this.$dic.getCategoryList(
        {
          cate_type: cate_type,
          level: '1',
        },
        res => {
          this.majorListData = res;
        }
      );

      this.$dic.getCategoryList(
        {
          cate_type: cate_type,
          level: '2',
          parentCode: '00',
        },
        res => {
          this.level2 = res;
        }
      );

      this.$dic.getCategoryList(
        {
          cate_type: cate_type,
          level: '3',
          parentCode: '00_01',
        },
        res => {
          this.level3 = res;
        }
      );
    },
    cancel() {
      this.$emit('handleDetailCancel', {});
    },
    submit() {
      let tempData = {
        _id: this.currentResource._id,
        model_name: this.currentResource.model_name,
        model_file: this.modelFile,
        profession: this.currentResource.profession,
        industry: this.currentResource.industry,
        model_category: this.currentResource.model_category,
        model_file_type: this.currentResource.model_file_type,
        function_category: this.currentResource.function_category,
        is_public: true,
        description: this.currentResource.description,
        remark: this.currentResource.remark,
        size: this.currentResource.size,
        brand: this.currentResource.brand,
        model_specification: this.currentResource.model_specification,
        origin: this.currentResource.origin,
        weight: this.currentResource.weight,
        material: this.currentResource.material,
        current_and_voltage: this.currentResource.current_and_voltage,
        capacity: this.currentResource.capacity,
        one_level_classify: this.currentResource.one_level_classify,
        status: this.currentResource.status,
        tags: this.currentResource.tags,
        isInternalModel: this.currentResource.isInternalModel,
        model_image: this.model_image,
      };

      updateModelResource(tempData)
        .then(res => {
          if (res.code === '200') {
            this.$notify({
              timeout: 1500,
              message: '操作成功！',
              icon: 'add_alert',
              horizontalAlign: 'center',
              verticalAlign: 'bottom',
              type: 'success',
            });
            this.$emit('handleDetailSubmit', res.data);
          } else {
            this.$notify({
              timeout: 1500,
              message: '操作失败',
              horizontalAlign: 'center',
              verticalAlign: 'bottom',
              type: 'warning',
            });
          }
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    async delete_() {
      let tempData = {
        _id: this.currentResource._id,
      };
      let result = await Swal.fire({
        title: '删除信息',
        text: `该设备模型被删除后将无法恢复，请确认！`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        buttonsStyling: false,
      });
      if (result.value) {
        await deleteResource(tempData).then(res => {
          if (res.code === '200') {
            this.$notify({
              timeout: 1500,
              message: '删除成功',
              icon: 'add_alert',
              horizontalAlign: 'center',
              verticalAlign: 'bottom',
              type: 'success',
            });
            this.$emit('handleDetailSubmit', res.data);
          } else {
            this.$notify({
              timeout: 1500,
              message: '操作失败',
              icon: 'add_alert',
              horizontalAlign: 'center',
              verticalAlign: 'bottom',
              type: 'warning',
            });
          }
        });
      }
    },
  },
};
</script>
<style lang="css" scoped>
.neiZhiYuanJian {
  display: none;
}
.v-card .v-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.img {
  width: 120px;
  height: 180px;
}

.md-group {
  margin-bottom: 24px;
}

.md-button {
  border-radius: 0;
}

.md-tab {
  max-width: 800px;
  max-height: 450px;
  overflow: auto;
}

@media (max-width: 599px) {
  .v-dialog__content >>> .v-dialog {
    background-color: red !important;
    max-width: 100% !important;
    margin: 24px 10px !important;
  }
  .BtnsWrap button {
    margin: 5px 0;
  }
  .neiZhiYuanJian {
    display: block;
  }
  .neiZhiYuanJianPc {
    display: none;
  }
}
</style>
